<template>
  <svg width="100" height="60" viewBox="0 0 100 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- Base -->
    <rect x="30" y="40" width="40" height="10" fill="black"/>

    <!-- Moving Arm -->
    <rect x="40" y="20" width="10" height="20" fill="#555">
      <animate attributeName="y" values="20;10;20" dur="1s" repeatCount="indefinite"/>
    </rect>

    <!-- Gear -->
    <circle cx="70" cy="30" r="10" fill="#888">
      <animateTransform attributeName="transform" type="rotate" from="0 70 30" to="360 70 30" dur="2s" repeatCount="indefinite"/>
    </circle>
  </svg>
</template>
